<template>
  <v-app>
    <router-view />

    <GlobalSnackbar />
  </v-app>
</template>

<script setup lang="ts">
/**
 * The root component of the application. It only contains the v-app wrapper
 * and the main router-view that handles rendering the correct layout.
 *
 * @author Alexander Funke
 * @lastChange 2025-09-18
 */
</script>
